import { createFileRoute } from '@tanstack/react-router';

import { DadataSettingsPage } from '../../../features/dadata/settings-page.tsx';
import { requireSettingsPermission } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/settings/dadata')({
  // Ключи и расход DaData — у того, кто ведёт реквизиты студии.
  beforeLoad: requireSettingsPermission('studio.manage'),
  component: DadataSettingsPage,
});
